import React from "react";
import { Link } from "react-router-dom";

const NavbarAdministration = props => {
  return (
    <nav className="navAdmin">
      <ul className="navLinksAdmin">
        <li>
          <Link to="/useradministration">Nutzer</Link>
        </li>
        <li>
          <Link to="/medicalrecordsadministration">Patientenakten</Link>
        </li>
        <li>
          <Link to="/appointmentsadministration">Termine</Link>
        </li>
        <li>
          <Link to="/adminrequests">Anfragen</Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavbarAdministration;
